module.exports = __webpack_public_path__ + "static/media/react.05a3e30f.svg";